import { render } from "./ComponenteConfiguracion.vue?vue&type=template&id=2dfb5ee6&scoped=true"
import script from "./ComponenteConfiguracion.vue?vue&type=script&lang=js"
export * from "./ComponenteConfiguracion.vue?vue&type=script&lang=js"

import "./ComponenteConfiguracion.vue?vue&type=style&index=0&id=2dfb5ee6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfb5ee6"]])

export default __exports__